<template>
  <div id="transportable-documents-page-header">
    <TransportableDocumentsFilterComponent
        :filters="registryFilter"
        @transport-orders-page-filter:updated="onFilterUpdated"
    />
  </div>

  <TransportableDocumentsRegistry :params="registryParams"/>
</template>

<script lang="ts">
import TransportableDocumentsFilter          from '@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsFilter';
import TransportableDocumentsFilterComponent from '@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsFilter.vue';
import TransportableDocumentsRegistry        from '@/domains/TransportableDocuments/components/TransportableDocumentsRegistry/TransportableDocumentsRegistry.vue';
import Shipment                              from '@/domains/Shipments/Shipment';
import TransportOrder from "@/domains/TransportOrders/TransportOrder";

type Role = 'electrostal' | 'general';

type RoleConfig = {
  preset: Partial<TransportableDocumentsFilter> | null;
};

const ROLE_CONFIG: Record<Role, RoleConfig> = {
  electrostal: {
    preset: {
      sellerTransportZone: [{ name: 'Москва и МО', id: 1 }, { name: 'СПб и ЛО', id: 5 }],
      documentClass:       [{ id: 'Shipment', name: Shipment.entityTypeName }, { id: 'TransportOrder', name: TransportOrder.entityTypeName } ],
    },
  },
  general: {
    preset: null,
  },
};

export default defineComponent({
  name: 'TransportableDocumentsPage',

  components: {
    TransportableDocumentsFilterComponent,
    TransportableDocumentsRegistry,
  },

  data() {
    const role: Role = (this.$route.params.role as Role) ?? 'general';
    const preset     = ROLE_CONFIG[role].preset;

    const registryFilter = TransportableDocumentsFilter.fromLocalStorage();
    if (preset !== null) {
      registryFilter.applyPreset(preset);
    }

    return { registryFilter };
  },

  computed: {
    registryParams() {
      return this.registryFilter.getRequestParams();
    },
  },

  methods: {
    onFilterUpdated(newFilter: TransportableDocumentsFilter): void {
      this.registryFilter = newFilter;
    },
  },
});
</script>
